import * as contentful from "contentful";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { insertNewsItem, insertNewsItemContent } from "./news-helpers";

(() => {
  const isEnglishPage = window.location.pathname.split("/")[1] === "en";
  const client = contentful.createClient({
    space: "avlb6sztnay6",
    environment: "master", // defaults to 'master' if not set
    accessToken: "4P7U8TjFmDgAaS0ht4rcZe26qPRfz8WppujCeEkYsQ8",
  });
  if (!isEnglishPage) {
    console.log(window.location.hash.slice(1));
    client
      .getEntries({
        content_type: "post",
        "fields.slug": window.location.hash.slice(1),
        locale: "es-PE",
      })
      .then((entry) => {
        console.log("Hello");
        console.log(entry);
        document.title = entry.items[0].fields.title;
        insertNewsItemContent(entry, "es");
      })
      .catch((error) => console.log("Not found", error.message));
  } else {
    client
      .getEntries({
        content_type: "post",
        "fields.slug": window.location.hash.slice(1),
        locale: "en-US",
      })
      .then((entry) => {
        console.log(entry);
        document.title = entry.items[0].fields.title;
        insertNewsItemContent(entry, "en");
      })
      .catch((error) => console.log("Not found", error.message));
  }
})();

(() => {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  const isEnglishPage = window.location.pathname.split("/")[1] === "en";
  const client = contentful.createClient({
    space: "avlb6sztnay6",
    environment: "master", // defaults to 'master' if not set
    accessToken: "4P7U8TjFmDgAaS0ht4rcZe26qPRfz8WppujCeEkYsQ8",
  });
  if (!isEnglishPage) {
    client
      .getEntries({
        content_type: "post",
        limit: 3,
        order: "sys.createdAt",
        locale: "es-PE",
      })
      .then((entry) => {
        entry.items.forEach((post) => {
          // console.log(post.fields.title);
          // console.log(post.fields.subtitle);
          // console.log(post.fields.slug);
          // console.log(post);
          // console.log(documentToHtmlString(post.fields.content));
          insertNewsItem(post, "es");
        });
      })
      .catch((error) => console.log("Not found", error.message));
  } else {
    client
      .getEntries({
        content_type: "post",
        limit: 3,
        order: "sys.createdAt",
        locale: "en-US",
      })
      .then((entry) => {
        entry.items.forEach((post) => {
          insertNewsItem(post, "en");
        });
      })
      .catch((error) => console.log("Not found", error.message));
  }
})();
